import { HardwareFingerprintService } from './../../shared/service/fingerprint.service';
import { IdleMonitorService } from './../../shared/service/idle-monitor.service';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { BehaviorSubject, Observable, take } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { InitializationStateEnum } from './enum/initialization-state.enum';
import { THEMES } from '../themes';
import { SignedInResultModel } from '../../module/iam/login/model/signed-in-result.model';
import { UserModel } from '../../module/iam/user-settings/model/user.model';
import { ThemeModel } from "../../shared/definition/model/theme.model";

@Injectable({
    providedIn: 'root'
})
export class SystemService {
    initialization$: BehaviorSubject<InitializationStateEnum> = new BehaviorSubject<InitializationStateEnum>(InitializationStateEnum.AWAITING);
    user$: BehaviorSubject<UserModel | undefined> = new BehaviorSubject<UserModel | undefined>(undefined);
    theme$: BehaviorSubject<string> = new BehaviorSubject('');

    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected fingerPrintService: HardwareFingerprintService,
        private idleMonitor: IdleMonitorService
    ) {}

    public initialize(route: ActivatedRoute, router: Router): void {
        this.theme$.next(this.getActualTheme());

        if (!this.getLocalStorage('token')) {
            this.setInitialized();
        }
    }
    public getLocalStorage(key: string): string | null {
        return localStorage.getItem(key);
    }

    public getActualTheme(): string {
        const actualTheme = this.getLocalStorage('theme');
        return actualTheme ? actualTheme: 'default-theme';
    }

    public getUser(): UserModel {
        return this.user$.getValue() as UserModel;
    }
    public haveUser(): boolean {
        return this.user$.getValue() !== undefined;
    }
    protected setInitialized(): void {
        this.initialization$.next(InitializationStateEnum.INITIALIZED);
    }
    public setLocalStorage(key: string, value: string): void {
        localStorage.setItem(key, value);
    }
    public setSignInInformation(signInResul: SignedInResultModel): void {
        this.setUser(signInResul.user);
        this.setLocalStorage('token', signInResul.session.token);
        this.setLocalStorage('sessionId', signInResul.session._id);
        this.setLocalStorage('userId', signInResul.session.userId);
    }
    public setTheme(theme: ThemeModel): void {
        const themeKey = theme.cssClass.replace('ui-', '');
        this.theme$.next(themeKey);
        this.setLocalStorage('theme', themeKey);
    }
    public setUser(user: any): void {
        this.user$.next(user);
        if (!this.initialization$.getValue()) {
            this.setInitialized();
        }
    }
    public signOut(url = this.router.url): void {
        this.setUser(undefined);
        this.removeLocalStorage('token');
        this.removeLocalStorage('sessionId');
        this.removeLocalStorage('userId');

        this.router.navigate(['/iam/sign/in'], {
            queryParams: {
                redirect: encodeURI(url)
            }
        });
    }
    public removeLocalStorage(key: string): void {
        localStorage.removeItem(key);
    }
    public watchInitialization(): Observable<InitializationStateEnum> {
        return this.initialization$;
    }
    public watchInitialized(): Observable<InitializationStateEnum> {
        return this.initialization$.pipe(
            filter(initialization => {
                return initialization === InitializationStateEnum.INITIALIZED
            }),
            take(1)
        );
    }
    public watchTheme(): Observable<string> {
        return this.theme$.pipe(
            filter((value: string) => value !== ''),
            map((theme: string) => {
                return THEMES[theme]['cssClass'] as string;
            })
        );
    }
    public watchUser(): Observable<UserModel | undefined> {
        return this.user$;
    }
    public async initializeDeviceId() {
        const deviceId = await this.fingerPrintService.generateStableId();
        this.setLocalStorage('genosStableId', deviceId);

        return deviceId;
    }
    public getDeviceId() {
        return this.getLocalStorage('genosStableId');
    }
    public isUserIdle(): boolean {
        return this.idleMonitor.isUserIdle();
    }
}
